import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Marketplace from "@/pages/Marketplace";
import CoachProfile from "@/pages/CoachProfile";
import CoachApply from "@/pages/CoachApply";
import Admin from "@/pages/Admin";
import ConnectDashboard from "@/pages/ConnectDashboard";
import BookingSuccess from "@/pages/BookingSuccess";
import CoachOnboarding from "@/pages/CoachOnboarding";
import CoachDashboard from "@/pages/CoachDashboard";
import SavedCoaches from "@/pages/SavedCoaches";
import CompareCoaches from "@/pages/CompareCoaches";
import MySessions from "@/pages/MySessions";
import AuthCallback from "@/pages/AuthCallback";
import TermsOfService from "@/pages/policy/TermsOfService";
import PrivacyPolicy from "@/pages/policy/PrivacyPolicy";
import RefundPolicy from "@/pages/policy/RefundPolicy";
import CoachGuidelines from "@/pages/policy/CoachGuidelines";
import TrustSafetyPolicy from "@/pages/policy/TrustSafety";
import { AuthProvider } from "@/context/AuthContext";
import SignInModal from "@/components/coachly/SignInModal";

// AppRouter — checks the URL fragment synchronously (via useLocation().hash)
// so Emergent Google Auth callbacks are processed BEFORE ProtectedRoute or
// the AuthProvider's /me check runs. This prevents race conditions.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/marketplace" element={<Marketplace />} />
      <Route path="/coach/:slug" element={<CoachProfile />} />
      <Route path="/apply" element={<CoachApply />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/connect" element={<ConnectDashboard />} />
      <Route path="/coach-onboarding" element={<CoachOnboarding />} />
      <Route path="/coach-dashboard" element={<CoachDashboard />} />
      <Route path="/saved" element={<SavedCoaches />} />
      <Route path="/compare" element={<CompareCoaches />} />
      <Route path="/my-sessions" element={<MySessions />} />
      <Route path="/booking/success" element={<BookingSuccess />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      {/* Legal / policy pages */}
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/coach-guidelines" element={<CoachGuidelines />} />
      <Route path="/trust-safety" element={<TrustSafetyPolicy />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <SignInModal />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors closeButton />
    </div>
  );
}

export default App;
